import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  convertAmount,
  gameConfigStore,
  isMobile,
  toFixed,
  userInfoStore,
} from '@pascal/pascal-core';
import { globalTranslationKeys } from '../../../enums';

const {
  Rtp,
  GameRulesP1,
  GameRulesP2,
  GameRulesP3,
  GameRulesP5,
  GameRulesP7,
  GameRulesP8,
  GameRulesP9,
  GameRulesP10,
  GameRulesP11,
  GameRulesP12,
  // GameRulesP13,
  GameRulesP14,
  GameRulesP15,
  GameRulesP16,
  GameRulesP17,
  GameRulesP18,
  GameRulesP19,
  GameRulesP20,
  GameRulesP21,
  GameRulesP22,
  GameRulesP23,
  GameRulesP24,
  MinCashOutOdd,
  MaxCashOutOdd,
  FrequencyRate,
  MaximumCoefficient,
} = globalTranslationKeys;

export const GameSpecificCheckHashPopupTopSection = ({ currentData, isFromBetHistory, t }) => {
  return (
    <div className='res-cont-circle-wrp'>
      <div className='crash-result-content'>
        {!!isFromBetHistory && (
          <div className='crash-result-cash-out-info-holder'>
            <div className='crash-result-cash-out-circle'>
              <p className='crash-result-cash-out-circle-txt'>x{currentData.odd}</p>
            </div>
            <p className='crash-result-cash-out-txt'>{t(globalTranslationKeys.CashOut)}</p>
          </div>
        )}
        <div className='crash-result-holder'>
          <p className='crash-result-value'>
            {(currentData.roundData && `x${currentData.roundData}`) ||
              (currentData.odd && `x${currentData.odd}`)}
          </p>
        </div>
      </div>
    </div>
  );
};

export const About = ({ t }) => {
  return (
    <div className='fs-help-popup-text'>
      <p className='heading' title={t(GameRulesP1)}>
        {t(GameRulesP1)}
      </p>
      <p className='heading' title={t(GameRulesP2)}>
        {t(GameRulesP2)}
      </p>
      <p className='hasCircle' title={t(GameRulesP3)}>
        {t(GameRulesP3)}
      </p>
      <p className='hasCircle' title={t(GameRulesP5)}>
        {t(GameRulesP5)}
      </p>
      <p className='hasCircle' title={t(GameRulesP7)}>
        {t(GameRulesP7)}
      </p>
      <p className='hasCircle' title={t(GameRulesP8)}>
        {t(GameRulesP8)}
      </p>
      <p className='hasCircle' title={t(GameRulesP9)}>
        {t(GameRulesP9)}
      </p>
      <p className='hasCircle' title={t(GameRulesP10)}>
        {t(GameRulesP10)}
      </p>
      <p className='hasCircle' title={t(GameRulesP19)}>
        {t(GameRulesP19)}
      </p>
      <p className='hasCircle' title={t(GameRulesP20)}>
        {t(GameRulesP20)}
      </p>
      <p className='hasCircle' title={t(GameRulesP23)}>
        {t(GameRulesP23)}
      </p>
      <p className='hasCircle' title={t(GameRulesP24)}>
        {t(GameRulesP24)}
      </p>
      <p> {t(Rtp)} </p>
    </div>
  );
};
export const AboutHashInnerContent = ({ t }) => {
  const {
    FairnessModalTitle,
    FairnessP1,
    FairnessP2,
    FairnessP3,
    FairnessP4,
    FairnessP5,
    FairnessP6,
    FairnessP7,
    FairnessP8,
    FairnessP9,
    FairnessP10,
    FairnessP11,
    FairnessP12,
  } = globalTranslationKeys;
  return (
    <>
      {isMobile() && (
        <p className='pr-f-text' title={t(FairnessModalTitle)}>
          {t(FairnessModalTitle)}
        </p>
      )}

      <p className='pr-f-text' title={t(FairnessP1)}>
        {t('FAIRNESS_P1')}
      </p>
      <p className='pr-f-text w-b-ba'>
        CE545547F79996444E87E12DC16F647C8E8EA2A0D948319D22DC930E8728047E2F91285D1CFD8805E9F764982D8328D11F3456354FA208EBEA78FA6693C03DB3
      </p>
      <p className='pr-f-text' title={t(FairnessP2)}>
        {t(FairnessP2)}
      </p>
      <p className='pr-f-text' title={t(FairnessP3)}>
        {t(FairnessP3)}
      </p>
      <p className='pr-f-text' title={t(FairnessP4)}>
        {t(FairnessP4)}
      </p>
      <p className='pr-f-text' title={t(FairnessP5)}>
        {t(FairnessP5)}
      </p>
      <p className='pr-f-text' title={t(FairnessP6)}>
        {t(FairnessP6)}
      </p>
      <p className='pr-f-text' title={t(FairnessP7)}>
        {t(FairnessP7)}
      </p>
      <p className='pr-f-text' title={t(FairnessP8)}>
        {t(FairnessP8)}
      </p>
      <p className='pr-f-text' title={t(FairnessP9)}>
        {t(FairnessP9)}
      </p>
      <p className='pr-f-text' title={t(FairnessP10)}>
        {t(FairnessP10)}
      </p>
      <p className='pr-f-text' title={t(FairnessP11)}>
        {t(FairnessP11)}
      </p>
      <p className='pr-f-text w-b-ba'>
        CE545547F79996444E87E12DC16F647C8E8EA2A0D948319D22DC930E8728047E2F91285D1CFD8805E9F764982D8328D11F3456354FA208EBEA78FA6693C03DB3
      </p>
      <p className='pr-f-text' title={t(FairnessP12)}>
        {t(FairnessP12)}
      </p>
    </>
  );
};

export const Details = observer(({ t }) => {
  const { currencySymbolOrCode } = userInfoStore;
  const { limits = {}, gameConfiguration = {} } = gameConfigStore;

  const { minBet, maxBet, maxWin } = limits;
  const { autobet: isAutoBetConfigEnabled } = gameConfiguration;

  return (
    <div className='fs-help-popup-text'>
      <p className='heading' title={t(GameRulesP12)}>
        {t(GameRulesP12)}
      </p>
      {/* <p className='hasCircle' title={t(GameRulesP13)}> */}
      {/*  {t(GameRulesP13)} */}
      {/* </p> */}

      <p
        className='hasCircle'
        title={t(GameRulesP16, { minBet, currencyCode: currencySymbolOrCode })}
      >
        {t(GameRulesP16, { minBet, currencyCode: currencySymbolOrCode })}
      </p>
      <p
        className='hasCircle'
        title={t(GameRulesP17, { maxBet, currencyCode: currencySymbolOrCode })}
      >
        {t(GameRulesP17, { maxBet, currencyCode: currencySymbolOrCode })}
      </p>
      <p
        className='hasCircle'
        title={t(GameRulesP18, { maxWin, currencyCode: currencySymbolOrCode })}
      >
        {t(GameRulesP18, { maxWin, currencyCode: currencySymbolOrCode })}
      </p>
      <p className='hasCircle' title={t(MinCashOutOdd)}>
        {t(MinCashOutOdd)}
      </p>
      <p
        className='hasCircle'
        title={t(MaxCashOutOdd, {
          minValue: convertAmount(toFixed(maxWin / maxBet)),
          maxValue: convertAmount(toFixed(maxWin / minBet)),
        })}
      >
        {t(MaxCashOutOdd, {
          minValue: convertAmount(toFixed(maxWin / maxBet)),
          maxValue: convertAmount(toFixed(maxWin / minBet)),
        })}
      </p>
      <p className='hasCircle' title={t(MaxCashOutOdd)}>
        {t(MaximumCoefficient)}
      </p>
      <p className='hasCircle' title={t(FrequencyRate)}>
        {t(FrequencyRate)}
      </p>
      {isAutoBetConfigEnabled && (
        <>
          <p className='hasCircle' title={t(GameRulesP14)}>
            {t(GameRulesP14)}
          </p>
          <p className='hasCircle' title={t(GameRulesP11)}>
            {t(GameRulesP11)}
          </p>
          <p className='hasCircle' title={t(GameRulesP21)}>
            {t(GameRulesP21)}
          </p>
        </>
      )}
      <p className='hasCircle' title={t(GameRulesP15)}>
        {t(GameRulesP15)}
      </p>
      <p className='hasCircle' title={t(GameRulesP22)}>
        {t(GameRulesP22)}
      </p>
    </div>
  );
});
